import { createContext, useState } from "react";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";

import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "../../../redux/actions/loadingActions/loadingActions";

import {
  setIsStartTimer,
  setIsStopTimer,
} from "../../../redux/actions/timerActions/timerActions";

import {
  changeProductActiveServices,
  getProductsListPublicService,
  postTransactionPublicService,
  productUpdateService,
} from "../../../services/userServices";

export const pricePublicContext = createContext({
  confirmModal: null,
  setConfirmModal: () => {},
  resultModal: null,
  setResultModal: () => {},
  orderModal: null,
  setOrderModal: () => {},
  data: [],
  setData: () => {},
  type: "",
  setType: () => {},
  change: "",
  stateWeight: "",
  setStateWeight: () => {},
  statePrice: "",
  setStatePrice: () => {},
  stateTotal: "",
  setStateTotal: () => {},
  counter: "",
  setCounter: () => {},
  bos: "",
  setBos: () => {},
  transactionId: "",
  setTransactionId: () => {},
  product_name: "",
  setProduct_name: () => {},
  customeruser: "",
  setCustomeruser: () => {},
  description: "",
  setDescription: () => {},
  is_orderi: null,
  setIs_orderi: () => {},
  //* Price List Start
  getItemsList: [],
  setGetItemsList: () => {},
  handleGetItemsList: () => {},
  //* Price List End
  //* Transaction End
  handlePostTransaction: () => {},
  //* Transaction Start
  handlePriceChange: () => {},
  handleWeightChange: () => {},
  handleTotalChange: () => {},
  addCommas: () => {},
  //* News Start
  openModal: null,
  setOpenModal: () => {},
  loading: null,
  setLoading: () => {},
  //* Update Product
  buyTolerance: {},
  setBuyTolerance: () => {},
  sellTolerance: {},
  setSellTolerance: () => {},
  handleChangeBuyPrice: () => {},
  handleChangeSellPrice: () => {},
  handleUpdateProduct: () => {},
  //* Timer Of Order
  isTimerOn: null,
  setIsTimerOn: () => {},
  handleStartTimer: () => {},
  //* Is Price Close
  handleChangeBuyClosePriceProduct: () => {},
  handleChangeSellClosePriceProduct: () => {},
});

const PricePublicContext = ({ children }) => {
  const dispatch = useDispatch();

  const [type, setType] = useState("buy");
  const [change] = useState("changed");
  const [data, setData] = useState([]);
  const [getItemsList, setGetItemsList] = useState([]);

  const [stateWeight, setStateWeight] = useState("");
  const [statePrice, setStatePrice] = useState("");
  const [stateTotal, setStateTotal] = useState("");

  const [bos, setBos] = useState("");
  const [tType, setTtype] = useState("E");
  const [is_orderi, setIs_orderi] = useState(true);
  const [description, setDescription] = useState("");
  const [product_name, setProduct_name] = useState("");
  const [transactionId, setTransactionId] = useState("");

  const [customeruser, setCustomeruser] = useState("");
  const [confirmModal, setConfirmModal] = useState(false);
  const [resultModal, setResultModal] = useState(false);
  const [orderModal, setOrderModal] = useState(true);

  const [counter, setCounter] = useState(0);

  const [openModal, setOpenModal] = useState(true);
  const [loading, setLoading] = useState(true);

  //* Timer Of Order
  const [isTimerOn, setIsTimerOn] = useState(false);

  //* Update Product
  const [buyTolerance, setBuyTolerance] = useState({});
  const [sellTolerance, setSellTolerance] = useState({});

  //* Handle Post Transaction Public
  // const handlePostTransaction = async (payload) => {
  //   const objData = payload || {
  //     amount: parseFloat(stateTotal),
  //     volume: parseFloat(stateWeight),
  //     price: parseFloat(statePrice),
  //     tType,
  //     description,
  //     bos,
  //     is_orderi,
  //     product_name,
  //     customeruser,
  //   };
  //   try {
  //     dispatch(setLoadingTrueAction());
  //     const { status } = await postTransactionPublicService(objData)
  //       .then((response) => {
  //         // console.log(objData);

  //         setResultModal(true);
  //         setConfirmModal(false);
  //         console.log("response.data", response.data);
  //         setTransactionId(response.data.transactionID);
  //       })
  //       .catch((error) => {
  //         // console.error("Error:", error);
  //       });
  //     if (status === 200) {
  //       handleGetItemsList();
  //       setStatePrice("");
  //       setStateWeight("");
  //       setStateTotal("");
  //       setBos("");
  //       setTtype("");
  //       setIs_orderi("");
  //       setDescription("");
  //       setProduct_name("");
  //       // console.log(product_name)
  //       // console.log(product_name)
  //       setCustomeruser("");
  //     }
  //   } catch ({ response }) {
  //     if (response) {
  //       if (response.status) {
  //         toast.error(response.data.message);
  //       }
  //     }
  //     dispatch(setLoadingFalseAction());
  //   }
  // };

  //* Handle Post Transaction Public
  const handlePostTransaction = async (payload) => {
    const objData = payload || {
      amount: parseFloat(stateTotal),
      volume: parseFloat(stateWeight),
      price: parseFloat(statePrice),
      tType,
      description,
      bos,
      is_orderi,
      product_name,
      customeruser,
    };

    try {
      dispatch(setLoadingTrueAction());
      const response = await postTransactionPublicService(objData);

      // اینجا status و data مستقیماً در دسترس هستند
      if (response.status === 200 || response.status === 201) {
        setResultModal(true);
        setConfirmModal(false);
        setTransactionId(response.data.transactionID);
        await handleGetItemsList();

        // ریست کردن فیلدها
        setStatePrice("");
        setStateWeight("");
        setStateTotal("");
        setBos("");
        setTtype("");
        setIs_orderi("");
        setDescription("");
        setProduct_name("");
        setCustomeruser("");

        toast.success(response.data.message || "معامله با موفقیت ثبت شد");
      }
    } catch (error) {
      // بررسی خطای برگشتی از سرور
      if (error.response) {
        const errorMessage =
          error.response.data?.message || "خطا در ثبت تراکنش";
        toast.error(errorMessage);

        // ست کردن نتیجه خطا برای نمایش در مودال
        setTransactionId(null); // این باعث می‌شود مودال خطا نمایش داده شود
        setResultModal(true);
      } else {
        toast.error("خطا در ارتباط با سرور");
        setTransactionId(null);
        setResultModal(true);
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  //* Handle Prices
  const handlePriceChange = (_item, e) => {
    e.preventDefault();
    const price = parseFloat(e.target.value.replace(/,/g, ""));
    const pricePerOne = isNaN(price)
      ? 0
      : _item.tag === "T"
        ? price / 4.3318
        : price;
    const weight = stateWeight;
    const total = (pricePerOne * weight).toFixed(0);
    setStatePrice(isNaN(price) ? 0 : price);
    setStateTotal(total);
  };

  //* Handle Weight
  const handleWeightChange = (_item, e) => {
    e.preventDefault();
    const pricePerOne = isNaN(statePrice)
      ? 0
      : _item.tag === "T"
        ? statePrice / 4.3318
        : statePrice;
    const inputValue = e.target.value;

    if (_item.tag === "S" && !/^\d+$/.test(inputValue)) {
      return;
    }

    // Check if the input is a valid number format (including the decimal point)
    if (/^\d*\.?\d*$/.test(inputValue)) {
      let limitedValue = inputValue;
      if (inputValue.includes(".")) {
        const parts = inputValue.split(".");
        if (parts[1].length >= 4) {
          return;
        } else {
          limitedValue = `${parts[0]}.${parts[1].slice(0, 3)}`;
        }
      }
      setStateWeight(limitedValue);
      const weight = parseFloat(inputValue);
      const total = (pricePerOne * (isNaN(weight) ? 0 : weight)).toFixed(0);
      setStateTotal(total);
    }
  };

  //* Handle Total
  const handleTotalChange = (_item, e) => {
    e.preventDefault();
    const total = parseFloat(e.target.value.replace(/,/g, ""));
    let pricePerOne = 0;
    if (_item.tag === "T") {
      pricePerOne = isNaN(statePrice) ? 0 : statePrice / 4.3318;
      const weight = total / pricePerOne;
      setStateTotal(isNaN(total) ? 0 : total);
      setStateWeight(isNaN(weight) ? 0 : weight.toFixed(3));
    } else {
      pricePerOne = isNaN(statePrice) ? 0 : statePrice;
    }
  };

  //* Handle Add Comma For Number
  const addCommas = (number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  //* Handle Get Items List
  const handleGetItemsList = async () => {
    try {
      const { status, data } = await getProductsListPublicService();
      if (status === 200) {
        setGetItemsList(data);
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toast.error(response.data.message);
        }
      }
    }
  };

  //* Handle Timer Of Order
  const handleStartTimer = () => {
    handlePostTransaction();

    const expiryTime = new Date().getTime() + 60000;
    dispatch(setIsStartTimer());
    localStorage.setItem("timerExpiryTime", expiryTime);

    setTimeout(() => {
      localStorage.removeItem("timerExpiryTime");
      dispatch(setIsStopTimer());
    }, 60000);
  };

  //! Update Product Part Start
  //* Buy Tolerance
  const handleChangeBuyPrice = (productId, action, tag) => {
    let newChange;
    const changeValue = tag === "T" ? 5000 : 10000;

    setBuyTolerance((prev) => {
      const currentChange = prev[productId]?.changeValue || 0;

      newChange =
        action === "buyIncrement"
          ? currentChange + changeValue
          : currentChange - changeValue;

      return {
        id: productId,
        tag,
        changeFormat: action,
        changeValue: newChange,
      };
    });
    setTimeout(() => {
      handleUpdateProduct({
        id: productId,
        tag,
        changeFormat: action,
        changeValue: Number(newChange),
      });
    }, 0);
  };

  //* Sell Tolerance
  const handleChangeSellPrice = (productId, action, tag) => {
    let newChange;
    const changeValue = tag === "T" ? 5000 : 10000;

    setSellTolerance((prev) => {
      const currentChange = prev[productId]?.changeValue || 0;

      newChange =
        action === "sellIncrement"
          ? currentChange + changeValue
          : currentChange - changeValue;

      return {
        id: productId,
        tag,
        changeFormat: action,
        changeValue: newChange,
      };
    });
    setTimeout(() => {
      handleUpdateProduct({
        id: productId,
        tag,
        changeFormat: action,
        changeValue: Number(newChange),
      });
    }, 0);
  };

  //* Handle Update Product
  const handleUpdateProduct = async (userData) => {
    const objData = { ...userData };
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await productUpdateService(objData);
      if (status === 200) {
        toast.success(data.message);
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toast.error(response.data.message);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  //* Change Buy Price Close Product
  const handleChangeBuyClosePriceProduct = async (
    id,
    is_buy_closed,
    periority,
    is_sell_closed,
    is_market_close,
  ) => {
    const objData = {
      id,
      is_buy_closed,
      periority,
      is_sell_closed,
      is_market_close,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await changeProductActiveServices(objData);
      if (status === 200) {
        handleGetItemsList();
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toast.error(response.data.message);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  //* Change Sell Price Close Product
  const handleChangeSellClosePriceProduct = async (
    id,
    is_sell_closed,
    periority,
    is_buy_closed,
    is_market_close,
  ) => {
    const objData = {
      id,
      is_sell_closed,
      periority,
      is_buy_closed,
      is_market_close,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await changeProductActiveServices(objData);
      if (status === 200) {
        handleGetItemsList();
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toast.error(response.data.message);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <pricePublicContext.Provider
      value={{
        is_orderi,
        setIs_orderi,
        description,
        setDescription,
        customeruser,
        setCustomeruser,
        product_name,
        setProduct_name,
        confirmModal,
        setConfirmModal,
        resultModal,
        setResultModal,
        orderModal,
        setOrderModal,
        data,
        setData,
        getItemsList,
        setGetItemsList,
        type,
        setType,
        change,
        stateWeight,
        setStateWeight,
        bos,
        setBos,
        statePrice,
        setStatePrice,
        stateTotal,
        setStateTotal,
        counter,
        setCounter,
        transactionId,
        setTransactionId,
        handleGetItemsList,
        handlePostTransaction,
        handlePriceChange,
        handleWeightChange,
        handleTotalChange,
        addCommas,
        openModal,
        setOpenModal,
        loading,
        setLoading,
        //* Timer Of Order
        isTimerOn,
        setIsTimerOn,
        handleStartTimer,
        //* Update Product
        buyTolerance,
        setBuyTolerance,
        sellTolerance,
        setSellTolerance,
        handleChangeBuyPrice,
        handleChangeSellPrice,
        handleUpdateProduct,
        //* Is Price Close
        handleChangeBuyClosePriceProduct,
        handleChangeSellClosePriceProduct,
      }}
    >
      {children}
    </pricePublicContext.Provider>
  );
};

export default PricePublicContext;
